<template>
    <div class="family-info">
        <div>
            <div class="shadow">
                <div style="display: flex;align-items: flex-end;">
                    <span class="d-title">家庭信息</span>
                    <span style="flex: 1;text-align: right;" class="d-edit" @click="isEdit = !isEdit">编辑</span>
                </div>
                <div style="margin-top: 0.2rem;">
                    <div style="background-color: #909399;height: 1px;width: 100%;"></div>
                </div>
                <div style="margin-top: 0.2rem;" id="b-content">
                    <div v-if="!isEdit" style="padding: 0.1rem 0 0.1rem 0;">
                        <div v-for="(item, index) in familyInfoFormLoop" :key="index">
                            <el-row type="flex" justify="space-between">
                                <el-col :span="5" class="col">家庭成员姓名:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.name }}</el-col>
                                <el-col :span="5" class="col">联系电话:</el-col>
                                <el-col :span="7" class="col-n col">{{ item.tel_phone }}</el-col>
                            </el-row>
                        </div>
                    </div>
                    <div v-else>
                        <el-form ref="familyInfoForm" :model="familyInfoForm" label-width="125px" size="medium">
                            <div v-for="(item, index) in familyInfoFormLoop" :key="index"
                                style="border-bottom: 1px solid #eeeaea;margin-bottom: 0.2rem;">
                                <el-form-item label="家庭成员姓名">
                                    <el-input v-model.trim="item.name" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话">
                                    <el-input v-model.trim="item.tel_phone" clearable></el-input>
                                </el-form-item>
                                <div style="text-align: right;margin-bottom:0.2rem;" v-if="index !== 0">
                                    <span style="color: #F56C6C;cursor: pointer" @click="delLoop(index)">
                                        <i class="el-icon-delete"></i>
                                        <span>删除本条</span>
                                    </span>
                                </div>
                            </div>
                            <div style="width: 100%;text-align: center;cursor: pointer;border: 1px dashed #ccc;height: 25px;border-radius: 8px;line-height: 25px;margin-bottom: 0.2rem;font-size: medium;"
                                @click="addfamilyInfoFrom">
                                + 新增
                            </div>
                            <div style="text-align: center;width: 100%!important;">
                                <el-button type="primary" @click="onSubmit">提交</el-button>
                                <el-button @click.native="isEdit = !isEdit">取消</el-button>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { common } from '../../../../static/mixins/common'
export default {
    name: 'familyInfo',
    mixins: [common],
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            familyInfoForm: {},
            familyInfoFormLoop: [
                {
                    name: '',
                    tel_phone: '',
                }
            ],
            isEdit: false,
            adminuserId: '',
            adminuserName: '',
        }
    },
    methods: {
        onSubmit() {
            this.$axios.put('api/api3_update_family_info', {
                formData: this.familyInfoFormLoop,
                admin_user_id: this.adminuserId
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.$message.success(data.msg)
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        getAdminUserfamilyInfo(admin_user_id) {
            this.resetForm()
            this.ysyMAdminUserFamilyInfoOptions = []
            this.ysyMGetAdminUserFamilyInfo(admin_user_id)
        },
        resetForm() {
            this.familyInfoFormLoop.map(item => {
                item.name = ''
                item.tel_phone = ''
            })
        },
        addfamilyInfoFrom() {
            this.familyInfoFormLoop.push({
                name: '',
                tel_phone: '',
            })
        },
        delLoop(no) {
            this.familyInfoFormLoop.splice(no, 1)
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                this.adminuserId = null
                if (n !== o) {
                    this.adminuserId = n
                    this.getAdminUserfamilyInfo(n)
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.adminuserName = n
                }
            }
        },
        ysyMAdminUserFamilyInfoOptions: {
            handler(n, o) {
                if (n !== o) {
                    if (n) {
                        this.familyInfoFormLoop = n
                        if (n.length === 0) {
                            this.familyInfoFormLoop = [
                                {
                                    name: '',
                                    tel_phone: '',
                                }
                            ]
                        }
                    }
                }
            },
        },
    },
    computed: {
        // educationName() {
        //     let education_name_arr = ['本地城镇', '本地农村', '外地城镇(省内)', '外地农村(省内)', '外地城镇(省外)', '外地农村(省外)']
        //     return education_name_arr[this.familyInfoForm.residence_type - 1]
        // },
        // residence_type() {
        //     let residence_type_arr = ['本地城镇', '本地农村', '外地城镇(省内)', '外地农村(省内)', '外地城镇(省外)', '外地农村(省外)']
        //     return residence_type_arr[this.familyInfoForm.residence_type - 1]
        // },
        // political_outlook() {
        //     let political_outlook_arr = ['团员', '党员', '群众', '其他']
        //     return political_outlook_arr[this.familyInfoForm.political_outlook - 1]
        // },
        // marital_status() {
        //     let marital_status_arr = ['未婚', '已婚', '离异', '丧偶', '分居']
        //     return marital_status_arr[this.familyInfoForm.marital_status - 1]
        // }
    }
}
</script>

<style scoped>
.d-title {
    font-size: x-large;
    font-weight: bold;
}

.d-edit {
    font-size: medium;
    font-weight: bold;
    color: #409EFF;
    cursor: pointer;
}

/* .col {
    font-size: larger;
    font-weight: bold;
} */

/* .col-n {
    color: slategrey;
} */

#b-content .el-row {
    margin-bottom: 0.6rem;
}

.shadow {
    padding: 0.3rem 0.6rem;
    border: 1px solid #ccc;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, .3);
    margin: 0.2rem;
}

.over-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#b-content>>>.el-form-item {
    width: 45% !important;
    display: inline-block !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/authority/UserInfoTab/FamilyInfo.vue